import { Theme } from '@/components/Block'
import GsuLoader from '@/components/GsuLoader'
import { UnitSize } from '@/constants/measured-scope'
import { SectionNavigationAction } from '@/shared/api-generated-types'
import CardRow from '@/widgets/v2/CardRow'
import VODClassCard, { Props as VODClassCardProps } from '@/widgets/v2/VODClassCard'

type CarouselOptions = false | UnitSize[] | 'always'

export interface VODClassCardRowProps {
  title?: string | null
  subtitle?: string | null
  theme?: Theme
  carousel?: CarouselOptions
  items: Partial<VODClassCardProps>[]
  className?: string
  navigationActions?: SectionNavigationAction[]
  fetching?: boolean
}
export type DeviceSizes = {
  [key in UnitSize]: boolean | undefined
}

const VODClassCardRow = ({
  title,
  subtitle,
  theme = 'white',
  navigationActions,
  items,
  className = '',
  fetching,
}: VODClassCardRowProps): JSX.Element => {
  if (fetching) return <GsuLoader consumeSpace />

  const classCards = items
    ? items.map((item) => {
        return <VODClassCard {...(item as VODClassCardProps)} key={`class_${item.id}`} />
      })
    : []

  return (
    <CardRow
      title={title}
      subtitle={subtitle}
      theme={theme}
      navigationActions={navigationActions}
      className={className}
    >
      {classCards}
    </CardRow>
  )
}

export default VODClassCardRow
